/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Overpay_Credit_Needs_CustomerInputs */

const vi_error_overpay_credit_needs_customer = /** @type {(inputs: Error_Overpay_Credit_Needs_CustomerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Khách lẻ không ghi được tiền dư vào công nợ. Chọn khách hàng hoặc trả tiền thừa cho khách.`)
};

/**

* @param {Error_Overpay_Credit_Needs_CustomerInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const error_overpay_credit_needs_customer = /** @type {((inputs?: Error_Overpay_Credit_Needs_CustomerInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Overpay_Credit_Needs_CustomerInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_error_overpay_credit_needs_customer(inputs)
});